import { withAnalysisStatePresenter } from './withAnalysisStatePresenter';
import { getQuizAnalysis, getItemAnalyses, getFetchInProgress, getGenerationInProgress, getAnalysisError, getStatusPollingInProgress } from '../../../../common/selectors/analyses';
import { setQuizAnalysis, setItemAnalyses, setFetchInProgress, setGenerationInProgress, setAnalysisError, setStatusPollingInProgress } from '../../../../common/actions/analyses';
import { getQuizAnalysis as fetchQuizAnalysis } from '../../../api/getQuizAnalysis';
import { getItemAnalyses as fetchItemAnalyses } from '../../../api/getItemAnalyses';
import { getAnalysesStatus as fetchAnalysesStatus } from '../../../api/getAnalysesStatus';
import { getAnalysesExport } from '../../../api/getAnalysesExport';
import { connect } from '../../../../common/react-redux';
import { bindActionCreators, compose } from 'redux';
import { getActiveQuizId } from '../../../../common/selectors/quizzes';
import { addError } from '../../../../common/actions/alerts';
import { featureOn } from '../../../../common/util/featureCheck';
var DEFAULT_POLLING_INTERVAL = 3000;
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    quizAnalysis: getQuizAnalysis(state),
    itemAnalyses: getItemAnalyses(state),
    fetchInProgress: getFetchInProgress(state),
    generationInProgress: getGenerationInProgress(state),
    statusPollingInProgress: getStatusPollingInProgress(state),
    analysisError: getAnalysisError(state),
    activeQuizId: ownProps.activeQuizId || getActiveQuizId(state),
    fetchQuizAnalysis: fetchQuizAnalysis,
    fetchItemAnalyses: fetchItemAnalyses,
    fetchAnalysesStatus: fetchAnalysesStatus,
    getAnalysesExport: getAnalysesExport,
    pollingInterval: ownProps.pollingInterval || DEFAULT_POLLING_INTERVAL,
    exportEnabled: featureOn('item_analysis_csv')
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    setQuizAnalysis: bindActionCreators(setQuizAnalysis, dispatch),
    setItemAnalyses: bindActionCreators(setItemAnalyses, dispatch),
    setFetchInProgress: bindActionCreators(setFetchInProgress, dispatch),
    setGenerationInProgress: bindActionCreators(setGenerationInProgress, dispatch),
    setAnalysisError: bindActionCreators(setAnalysisError, dispatch),
    addError: ownProps.addError || bindActionCreators(addError, dispatch),
    setStatusPollingInProgress: bindActionCreators(setStatusPollingInProgress, dispatch)
  };
};
export var withAnalysisState = compose(connect(mapStateToProps, mapDispatchToProps), withAnalysisStatePresenter);
export default withAnalysisState;